/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Metadata_HeaderInputs */



/**
* | output |
* | --- |
* | "****METADATA****" |
*
* @param {Transcript_Export_Metadata_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_metadata_header = /** @type {((inputs?: Transcript_Export_Metadata_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Metadata_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("****METADONNEES****")
	if (locale === "de") return /** @type {LocalizedString} */ ("****METADATEN****")
	if (locale === "it") return /** @type {LocalizedString} */ ("****METADATI****")
	if (locale === "ru") return /** @type {LocalizedString} */ ("****МЕТАДАННЫЕ****")
	if (locale === "es") return /** @type {LocalizedString} */ ("****METADATOS****")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("****元数据****")
	if (locale === "ja") return /** @type {LocalizedString} */ ("****メタデータ****")
	if (locale === "hi") return /** @type {LocalizedString} */ ("****मेटाडेटा****")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("****METADADOS****")
	return /** @type {LocalizedString} */ ("****METADATA****")
});